import { MemberAccount } from "../../domain/models/MemberAccount";
import { PointTransactionForHistory } from "../../domain/models/PointTransactionForHistory";
import { Reward } from "../../domain/models/Reward";

export const CurrentPageActionType = {
  Search: 'search',
  Account: 'account',
  ExchangePoints: 'exchange-points',
}

export interface MemberAccountGroupData {
  memberAccount: MemberAccount;
  membershipLevelRewardList: Reward[];
  pointsHistory: PointTransactionForHistory[];
  cashbackDetails?: {
    lastOrderDate?: Date | null;
    ordersCount?: number | null;
    cashbackExpiresAt?: Date | null;
    formattedCashbackExpiresAt?: string | null;
    couponCode?: string | null;
    discountValue?: number | null;
  } | null;
}